import axios from "axios";
import moment from "moment";
import { reportError } from "./reportError";


//* Realiza el proceso de guardar la solicitud de factura con todo y su detalle
export const insertSolicitudFactura = async(props) => {

    let values = {...props}
    console.log({ values });
    
    // pasamos el RFC a mayusculas y sin espacios en blanco
    const rfcTmp = values.rfcCliente.trim().toUpperCase();
    values.rfcCliente = rfcTmp;

    let result = [];

    // - Creamos el cliente con los datos ingresados por el participante...
    let Cliente = [];

    Cliente.clienteID = values.clienteID || 0;
    Cliente.numeroCliente = values.numeroCliente || 0;
    Cliente.nombreCliente = values.nombreCliente;
    Cliente.rfcCliente = values.rfcCliente;
    Cliente.codigoPostal = values.codigoPostal;
    Cliente.email = values.correoElectronico;
   
    console.log(Cliente); // Aqui ya tenemos el cliente

    // - de 'PresupuestoCatalogoProyectos' recuperamos el registro por la clave de proyecto
    let Proyecto = [];
    result = [];
    const url3 = `${process.env.REACT_APP_BASE_URL}/api/PresupuestoCatalogoProyectos?claveProyecto=${values.proyecto}`;

    await axios.get(url3)
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{values}, task:"Proy recover|" + err }) );
    // Si no se pudo recuperar el dato regresa exito=0 y el mensaje correspondiente
    if (result.exito === 0) return { exito: 0, mensaje: "Error GET proyecto" };
    // Aqui ya tenemos el proyecto
    Proyecto = result.data[0];
    console.log(Proyecto);
    
    // - de 'CatalogoCuentasBancarias' recuperamos el registro por la cuentaBancaria y el año del registro del proyecto
    const cuenta = Proyecto.cuentaBancaria;
    // console.log(cuenta);
    const ejercicio = moment().format("YYYY");
    // console.log(ejercicio);
    let CuentaBancaria = [];
    result = [];
    const url4 = `${process.env.REACT_APP_BASE_URL}/api/CatalogoCuentasBancarias?cta=${cuenta}&ejercicio=${ejercicio}`;
    await axios.get(url4)
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{cuenta, ejercicio}, task:"CtaBanc recover|" + err }) );
    // Si no se pudo recuperar el dato regresa exito=0 y el mensaje correspondiente
    if (result.exito === 0) return { exito: 0, mensaje: "Error GET cuenta bancaria" };
    // Aqui ya tenemos la cuenta bancaria
    CuentaBancaria = result.data[0];
    console.log(CuentaBancaria);
    

    // - de 'CatalogoPlazaBancos' recuperamos el registro por el numero de plaza
    const num = (CuentaBancaria.clabeInterbancaria).slice(3, 6);
    let PlazaBanco = [];
    result = [];
    const url5 = `${process.env.REACT_APP_BASE_URL}/api/CatalogoPlazaBancos?num=${num}`;
    await axios.get(url5)
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{num}, task:"PlazaBanc recover|" + err }) );
    // Si no se pudo recuperar el dato regresa exito=0 y el mensaje correspondiente
    if (result.exito === 0) return { exito: 0, mensaje: "Error GET plaza banco" };
    // Aqui ya tenemos el resultado
    PlazaBanco = result.data[0];
    console.log(PlazaBanco);

    // - de 'RegimenFiscal' recuperamos el registro por la clave
    const clave = values.regimenFiscalID;
    let RegimenFiscal = [];
    result = [];
    const url6 = `${process.env.REACT_APP_BASE_URL}/api/RegimenFiscal?clave=${clave}`;
    await axios.get(url6)
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{values}, task:"RegFiscal recover|" + err }) );
    // Si no se pudo recuperar el dato regresa exito=0 y el mensaje correspondiente
    if (result.exito === 0) return { exito: 0, mensaje: "Error GET RegimenFiscal" };
    // Aqui ya tenemos el resultado
    RegimenFiscal = result[0];
    console.log(RegimenFiscal);

    /**
     * 
     *          Insertamos la solicitud de factura
     * 
     */

    let SolicitudFactura = [];
    result = [];

    let sValues = {
        "Folio": 0, 
        "Fecha": values.fecha, 
        "ClienteID": Cliente.clienteID, 
        "NumeroCliente": Cliente.numeroCliente, 
        "NombreCliente": Cliente.nombreCliente, 
        "RFCCliente": Cliente.rfcCliente, 
        "CodigoPostal": Cliente.codigoPostal, 
        "CorreoElectronico": Cliente.email, 
        "CorreoEvento": values.correoEvento, 
        "RegimenFiscalID": RegimenFiscal.regimenFiscalID, 
        "RegimenFiscalDescripcion": RegimenFiscal.descripcion, 
        "Proyecto": Proyecto.claveProyecto, 
        "ProyectoDescripcion": Proyecto.descripcionProyecto, 
        "TipoFactura": "INGRESO", 
        "TipoPago": "DEPOSITO", 
        "NumeroRegistro": values.NumeroRegistro, 
        "BancoID": CuentaBancaria.bancoID, 
        "BancoNombre": "BBVA BANCOMER, SA", 
        "BancoCuenta": CuentaBancaria.numeroCuentaBancaria, 
        "BancoClabe": CuentaBancaria.clabeInterbancaria, 
        "BancoPlaza": `${PlazaBanco.ciudad}, ${PlazaBanco.estado}`, 
        "BancoSucursal": PlazaBanco.numero, 
        "BancoTitular": "CENTRO DE INVESTIGACIONES BIOLÓGICAS DEL NOROESTE, S.C.", 
        "MetodoPago": "PUE", 
        "FormaPago": values.formaPago, 
        "Moneda": "MXN", 
        "TipoCambio":1.0, 
        "UsoCFDI": values.usoCFDI, 
        "CondicionPago": "EFECTOS FISCALES AL PAGO", 
        "Estado": "PENDIENTE", 
        "EnvioSolicitud": values.envioSolicitud, 
        "Area": "PROPIOS", 
        "Factura": null, 
        "SolicitanteID": values.solicitanteID, 
        "UnidadID": 1, 
        "Ejercicio": values.ejercicio, 
        "TipoDocumento": null, 
        "ArchivoPDF": values.archivoPDF, 
        "QuienRegistro": values.quienRegistro, 
        "FechaEnvio": values.fecha, 
        "Motivo": null
    };

    console.log(sValues);
    const url7 = `${process.env.REACT_APP_BASE_URL}/api/CajaGeneralSolicitudFactura`;

    await axios.post( url7, null, { params: {sValues} } )
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{sValues}, task:"SolFact post|" + err }) );
        
    // Aqui ya tenemos la SolicitudFactura
    if (result.exito === 1) {
        SolicitudFactura = result.data[0];
        console.log("SolicitudFactura", SolicitudFactura);
    } else {
        // El server respondió 0 o 2

        // Notificamos al developer
        reportError({ emailTo:"jcollins@cibnor.mx", values:{values}, task:"SolicitudFactura insert|" + result.mensaje });

        // Regresamos el result para que el componente que lo invoca pueda notificar al usuario
        return result;
    }



    // - de 'CajaGeneralCatalogoProductoServicio' recuperamos el registro por la clave
    const claveProd = Proyecto.claveServicioFacturacion;
    let ProductoServicio = [];
    result = [];
    const url8 = `${process.env.REACT_APP_BASE_URL}/api/CajaGeneralCatalogoProductoServicio?clave=${claveProd}`;
    await axios.get(url8)
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{claveProd}, task:"CatProdServ recover|" + err }) );
    // Si no se pudo recuperar el dato regresa exito=0 y el mensaje correspondiente
    if (result.exito === 0) return { exito: 0, mensaje: "Error GET plaza banco" };
    // Aqui ya tenemos el resultado
    ProductoServicio = result.data[0];
    console.log(ProductoServicio);

    // - Insertamos el detalle de factura
    let SolicitudFacturaDetalle = [];
    result = [];

    const calcCostoUnit = Number(values.importe) / ( 1.0 + (ProductoServicio.porcentajeIva / 100) );
    const calcImporteIva = Number(values.importe) - calcCostoUnit;
    console.log({calcCostoUnit, calcImporteIva});
    sValues = {
        Cantidad: 1.0, 
        CodigoProducto: ProductoServicio.clave, 
        CostoUnitario: calcCostoUnit, 
        Descripcion: ProductoServicio.descripcion, 
        ImporteIva: calcImporteIva,
        Observaciones: '',
        PorcentajeIva: ProductoServicio.porcentajeIva, 
        ProductoServicioID: ProductoServicio.productoServicioID, 
        SATClaveUM: ProductoServicio.satClaveUnidad, 
        SATCodigo: ProductoServicio.satClaveProductoServicio, 
        SATDescripcion: null, 
        SATDescripcionUM: null, 
        SolicitudID: SolicitudFactura.solicitudID, 
    };
    const url9 = `${process.env.REACT_APP_BASE_URL}/api/CajaGeneralSolicitudFacturaDetalle`;

    await axios.post( url9, null, { params: {sValues} } )
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{sValues}, task:"DetFact post|" + err }) );

    // Aqui ya tenemos la SolicitudFacturaDetalle
    if (result.exito === 1) {
        SolicitudFacturaDetalle = result.data[0];
        console.log("SolicitudFacturaDetalle", SolicitudFacturaDetalle);
    } else {
        reportError({ emailTo:"jcollins@cibnor.mx", values:{values}, task:"SolicitudFacturaDetalle insert|" + result });
        return { exito: 0, mensaje: "SolicitudFacturaDetalle insert" };
    }

    return { exito: 1, mensaje: "Solicitud de factura ingresada: " + SolicitudFacturaDetalle };
};

